var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.596,
    height: 24.093,
    viewBox: "0 0 34.596 24.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3103",
    "data-name": "Groupe 3103",
    transform: "translate(-279.68 -590.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye",
    d: "M9.779,14.668C3.427,14.668,0,9.462,0,7.334S3.427,0,9.779,0s9.779,5.205,9.779,7.334S16.131,14.668,9.779,14.668Zm0-13.038C4.25,1.63,1.63,6.2,1.63,7.334s2.621,5.7,8.149,5.7,8.149-4.575,8.149-5.7S15.307,1.63,9.779,1.63Zm0,9.779a4.074,4.074,0,1,1,4.074-4.074A4.079,4.079,0,0,1,9.779,11.408Zm0-6.519a2.445,2.445,0,1,0,2.445,2.445A2.448,2.448,0,0,0,9.779,4.889Z",
    transform: "translate(279.68 595)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3102",
    "data-name": "Groupe 3102",
    transform: "translate(-221.639 197.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2620",
    "data-name": "Groupe 2620",
    transform: "translate(522.858 392.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_703",
    "data-name": "Trac\\xE9 703",
    d: "M532.158,412.627V399.758h1.027a.624.624,0,0,0,.624-.623v-5.586a.623.623,0,0,0-.624-.622h-7.6a.623.623,0,0,0-.623.622v5.586a.623.623,0,0,0,.623.623h1.028v12.867c-1.521.219-3.756.768-3.756,2.1,0,1.809,4.1,2.291,6.528,2.291s6.528-.482,6.528-2.291C535.914,413.407,533.747,412.853,532.158,412.627Zm-5.949-14.113v-4.341h6.353v4.341h-.4v-2.477a.624.624,0,0,0-.623-.623h-4.3a.624.624,0,0,0-.623.623v2.477Zm1.651,9.057V396.659h3.051V407.57Zm3.051,1.246v5.289h-3.051v-5.289Zm-1.526,6.958c-3.4,0-5.137-.768-5.29-1,.057-.119.666-.59,2.518-.881v.838a.624.624,0,0,0,.623.623h4.3a.624.624,0,0,0,.623-.623v-.841a5.777,5.777,0,0,1,2.517.8C534.523,415.006,532.784,415.774,529.386,415.774Z",
    transform: "translate(-522.858 -392.927)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionAnalysis);
export default __webpack_public_path__ + "static/media/transaction-analysis.3c25dc09a9962ac9fc87e2de4389d76b.svg";
export { ForwardRef as ReactComponent };